import ColorPicker from 'lib/ui/ColorPicker'
import {onUnknownChangeHandler} from 'lib/dom'
import Select from 'lib/ui/Select'
import Option from 'lib/ui/Select/Option'
import {useLeftyTemplate} from 'Event/template/Lefty'
import React from 'react'
import {Controller, UseFormMethods} from 'react-hook-form'

export const SPEAKER_ALIGN_LEFT = 'left'
export const SPEAKER_ALIGN_CENTER = 'center'
export const SPEAKER_ALIGN_RIGHT = 'right'

export default function Styling(props: {control: UseFormMethods['control']}) {
  const {control} = props
  const template = useLeftyTemplate()

  return (
    <>
      <Controller
        name="speakers.carouselArrowColor"
        defaultValue={template.speakers.carouselArrowColor}
        control={control}
        render={({value, onChange}) => (
          <ColorPicker
            label="Carousel Arrow Color"
            color={value}
            onPick={onChange}
            aria-label="carousel arrow color"
          />
        )}
      />
      <Controller
        name="speakers.align"
        defaultValue={template.speakers.align}
        control={control}
        render={({value, onChange}) => (
          <Select
            fullWidth
            label="Speakers Align"
            value={value}
            onChange={onUnknownChangeHandler(onChange)}
          >
            <Option value={SPEAKER_ALIGN_LEFT}>Left</Option>
            <Option value={SPEAKER_ALIGN_CENTER}>Center</Option>
            <Option value={SPEAKER_ALIGN_RIGHT}>Right</Option>
          </Select>
        )}
      />
    </>
  )
}
